import { render, staticRenderFns } from "./AddGetMaxFormulaComponent.vue?vue&type=template&id=b6c1fc20&scoped=true"
import script from "./AddGetMaxFormulaComponent.vue?vue&type=script&lang=js"
export * from "./AddGetMaxFormulaComponent.vue?vue&type=script&lang=js"
import style0 from "./AddGetMaxFormulaComponent.vue?vue&type=style&index=0&id=b6c1fc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c1fc20",
  null
  
)

export default component.exports